export const actions = {
  getAddress ({ commit, dispatch }, params) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address/?query=${params.query || ''}&count=15`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${__config.dadata_api_key}`
          }
        })
        const json = await response.json()
        resolve(json.suggestions || [])
      } catch (e) {
        reject(e)
      }
    })
  }
}
